import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, spacing } from 'ui/theme';
import { Button, DockingBar } from '@iterable/deprecated_react_components';

export const StateButtonsContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const StyledCoreDockingBar = styled(DockingBar)`
  &&&&&&&&& {
    box-shadow: 0;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
    transition: box-shadow 0.2s;
    &.cssStateButtonsDocked {
      /** css conversion */
      padding: 0 ${pxToRem(40)};
      position: fixed;
      top: ${pxToRem(65)} !important;
      right: -${pxToRem(35)};
      width: auto !important;
      ${StateButtonsContainer} {
        /** css conversion */
        background: ${colors.white};
        border-radius: ${pxToRem(3)};
        box-shadow: 0 0 ${pxToRem(8)} rgba(0, 0, 0, 0.4);
        margin: -${pxToRem(10)};
        padding: ${pxToRem(10)};
      }
    }
  }
`;

export const StyledCoreButtonGroup = styled(Button.Group)``;

export const StyledCoreButton = styled(Button)`
  &&&&&&& {
    margin: 0;
    & [data-selected='true'] {
      box-shadow: none;
    }
  }
`;
